import TEXTS from './texts';

export const DEFAULT_LANG = 'en';

const ALIASES = {
  ua: 'uk',
};

const normalize = (code) => {
  const short = String(code || '')
    .toLowerCase()
    .split(/[-_]/)[0];

  return ALIASES[short] || short;
};

const detectLang = () => {
  const params = new URLSearchParams(window.location.search);
  const forced = normalize(params.get('lang'));

  if (TEXTS[forced]) return forced;

  const candidates = navigator.languages || [navigator.language || DEFAULT_LANG];

  for (let i = 0; i < candidates.length; i += 1) {
    const code = normalize(candidates[i]);

    if (TEXTS[code]) return code;
  }

  return DEFAULT_LANG;
};

export default detectLang;
